import { Link } from "react-router-dom";
import Ornament from "@/components/Ornament";
import ProductRow from "@/components/ProductRow";
import { t, catLabel } from "@/lib/i18n";

export default function SearchResults({ results, query, lang }) {
  return (
    <section data-testid="search-results" className="pt-6">
      <h2 className="font-display text-2xl text-[var(--bordeaux)] font-semibold">
        {t(lang, "resultsFor")} “{query.trim()}”
      </h2>
      <Ornament />
      {results.length === 0 ? (
        <p data-testid="search-no-results" className="text-sm text-[var(--muted)] italic py-6 text-center">
          {t(lang, "noResults")}
        </p>
      ) : (
        <div className="bg-[var(--card)] border border-[var(--line)] rounded-lg px-4 shadow-sm">
          {results.map((prod) => (
            <div key={prod.id} className="relative">
              <Link
                to={`/menu/${prod.categorySlug}`}
                className="absolute right-0 top-3 text-[10px] font-cinzel tracking-widest uppercase text-[#B89248]"
                data-testid={`search-result-cat-${prod.id}`}
              >
                {catLabel(prod.categorySlug, lang)}
              </Link>
              <ProductRow product={prod} />
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
